import React, { useEffect, useMemo, useState } from "react";
import {
    AppBar,
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    LinearProgress,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    TextField,
    Toolbar,
    Tooltip,
    Typography,
    Stack,
    Chip
} from "@mui/material";
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CloseIcon from "@mui/icons-material/Close";
// import api from '../services/api';
import { alpha } from '@mui/material/styles';
import TodayIcon from '@mui/icons-material/Today';
import ReceiptLongIcon from '@mui/icons-material/Receipt';


import FinanceDetailsDrawer from './FinanceDetailsDrawer';

// ==== CONFIG API
const API_URL = process.env.REACT_APP_API_BACKEND || "http://localhost:9002";
const instancia = process.env.REACT_APP_INSTANCIA;

// async function apiFetch(path, options = {}) {

//     const token = localStorage.getItem('token');
//     if (!token) {
//         return;
//     }


//     const res = await fetch(`${API_URL}${path}`, {
//         headers: { "Content-Type": "application/json", ...(options.headers || {}) },
//         ...options,
//     });
//     if (!res.ok) {
//         const text = await res.text();
//         throw new Error(text || `HTTP ${res.status}`);
//     }
//     const ct = res.headers.get("content-type") || "";
//     if (ct.includes("application/json")) return res.json();
//     console.log(res);

//     return res.text();
// }

async function apiFetch(path, options = {}) {
    const token = localStorage.getItem('token');
    if (!token) {
        // Se não houver token, você pode optar por não fazer a requisição
        // ou lidar com a situação de outra forma, como um erro
        console.error("Token não encontrado.");
        return;
    }

    const res = await fetch(`${API_URL}${path}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // Adiciona o cabeçalho Authorization
            ...(options.headers || {})
        },
        ...options,
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `HTTP ${res.status}`);
    }

    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) return res.json();

    console.log(res);
    return res.text();
}

function KpiCard({ title, value, icon, help, currency, onClick }) {
    return (
        <Paper
            onClick={onClick}
            sx={{
                p: 2,
                borderRadius: 4,
                height: '100%',
                cursor: onClick ? 'pointer' : 'default',
                userSelect: 'none',
            }}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : -1}
            onKeyDown={(e) => {
                if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography variant="overline">{title}</Typography>
                    {help && (
                        <Tooltip title={help}>
                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />
                        </Tooltip>
                    )}
                </Box>
                <Box sx={{ opacity: 0.8 }}>{icon}</Box>
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: 26 }}>
                {currency(Number(value || 0))}
            </Typography>
        </Paper>
    );
}

export default function FinanceHome() {

    const navigate = useNavigate();

    // ======= State principal
    const [loading, setLoading] = useState(false);
    const [snack, setSnack] = useState("");

    const [resumo, setResumo] = useState(null); // { cicloId, status, valorCargaInicial, totalRecargas, totalVendas, saldoCaminhao, dataInicio, dataFim }

    // Estados de details
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [detailsTab, setDetailsTab] = useState('vendas'); // 'vendas' | 'despesas'
    const openDetails = (tab = 'vendas') => {
        if (!resumo?.cicloId) {
            setSnack('Abra um ciclo para ver os detalhes deste caminhão.');
            return;
        }
        setDetailsTab(tab);
        setDetailsOpen(true);
    };

    // Resumo do dia
    const [hoje, setHoje] = useState(() => new Date().toISOString().slice(0, 10));
    const [resumoDia, setResumoDia] = useState({ vendas: 0, despesas: 0 });

    // Chip de status (helper)
    const statusChipProps = useMemo(() => {
        const s = String(resumo?.status || '').toUpperCase();
        if (s === 'ABERTO') return { label: 'ABERTO', color: 'success', variant: 'outlined' };
        if (s === 'FECHADO') return { label: 'FECHADO', color: 'default', variant: 'filled' };
        return { label: 'SEM CICLO', color: 'warning', variant: 'outlined' };
    }, [resumo?.status]);


    // helper de label do caminhão (opcional, bom pro header do drawer)
    const [caminhoes, setCaminhoes] = useState([]);
    const [caminhaoId, setCaminhaoId] = useState(
        () => localStorage.getItem("fin_caminhaoId") || ""
    );

    // modal Pagamento
    const [dlgPagamento, setDlgPagamento] = useState(false);
    const [pagData, setPagData] = useState(() => new Date().toISOString().slice(0, 10));
    const [pagValor, setPagValor] = useState('');
    const [pagFormaId, setPagFormaId] = useState('');
    const [pagFavorecido, setPagFavorecido] = useState('');
    const [pagObs, setPagObs] = useState('');
    const [pagStatus, setPagStatus] = useState('EFETIVADO');

    // Fornecedores
    const [fornecedor, setFornecedor] = useState([]);
    const [fornecedorSelected, setFornecedorSelected] = useState(0);

    // helper
    const asArray = (x) => {
        if (Array.isArray(x)) return x;
        if (!x || typeof x !== 'object') {
            // tenta string JSON
            if (typeof x === 'string') {
                try {
                    const parsed = JSON.parse(x);
                    return asArray(parsed);
                } catch { return []; }
            }
            return [];
        }
        // tenta chaves comuns
        if (Array.isArray(x.itens)) return x.itens;
        if (Array.isArray(x.rows)) return x.rows;
        if (Array.isArray(x.data)) return x.data;
        if (Array.isArray(x.result)) return x.result;
        return [];
    };

    const today = () => new Date().toISOString().slice(0, 10);

    // --- Vendas
    const resetVendaForm = () => {
        setVendaValores({});      // { [formaId]: '' }
        setVendaData(today());    // se você usa vendaData
        setVendaObs('');          // se você usa observação
    };

    // --- Pagamentos (se estiver usando)
    const resetPagamentoForm = () => {
        setPagData(today());
        setPagValor('');
        setPagFormaId('');
        setPagFavorecido('');
        setPagObs('');
        setPagStatus('EFETIVADO');
    };

    // --- Despesas (se estiver usando)
    const resetDespesaForm = () => {
        setDespData(today());
        setDespValor('');
        // setDespCategoriaId && setDespCategoriaId('');
        setDespObs && setDespObs('');
    };


    const abrirRelatorios = () => {
        if (!caminhaoId || !competencia) {
            setSnack('Selecione o caminhão e a competência.');
            return;
        }
        navigate(`/finance/relatorios?caminhaoId=${caminhaoId}&competencia=${competencia}`);
    };

    const abrirRelatoriosNovaAba = () => {
        if (!caminhaoId || !competencia) {
            setSnack('Selecione o caminhão e a competência.');
            return;
        }
        const url = `/finance/relatorios?caminhaoId=${caminhaoId}&competencia=${competencia}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const [formas, setFormas] = useState([]);
    const [categorias, setCategorias] = useState([]);

    // useMemo seguro
    const caminhoesArr = useMemo(() => asArray(caminhoes), [caminhoes]);

    const caminhaoLabel = useMemo(() => {
        const c = caminhoesArr.find(x => String(x.id) === String(caminhaoId));
        return c ? (c.identificacao ? `${c.placa} • ${c.identificacao}` : c.placa) : null;
    }, [caminhoesArr, caminhaoId]);

    const [competencia, setCompetencia] = useState(
        () => localStorage.getItem("fin_competencia") || new Date().toISOString().slice(0, 7)
    ); // YYYY-MM

    // Dialogs
    const [dlgVenda, setDlgVenda] = useState(false);
    const [dlgDespesa, setDlgDespesa] = useState(false);
    const [dlgRecarga, setDlgRecarga] = useState(false);
    const [dlgCiclo, setDlgCiclo] = useState(false);

    // Fechamento do ciclo
    const [dlgFechar, setDlgFechar] = useState(false);
    const [fecharData, setFecharData] = useState(() => new Date().toISOString().slice(0, 10));
    const [fecharSobra, setFecharSobra] = useState('');
    const [fecharObs, setFecharObs] = useState('');


    // Forms diálogo
    const [vendaData, setVendaData] = useState(() => new Date().toISOString().slice(0, 10));
    const [vendaValores, setVendaValores] = useState({}); // { formaId: valor }
    const [vendaObs, setVendaObs] = useState("");

    const [despData, setDespData] = useState(() => new Date().toISOString().slice(0, 10));
    const [despCategoria, setDespCategoria] = useState("");
    const [despValor, setDespValor] = useState("");
    const [despObs, setDespObs] = useState("");

    const [recData, setRecData] = useState(() => new Date().toISOString().slice(0, 10));
    const [recValor, setRecValor] = useState("");
    const [recObs, setRecObs] = useState("");

    const [totaisMes, setTotaisMes] = useState(null);

    const [cicloCargaInicial, setCicloCargaInicial] = useState("");
    const [cicloDataInicio, setCicloDataInicio] = useState(() => {
        const y = competencia.slice(0, 4); const m = competencia.slice(5, 7);
        return `${y}-${m}-01`;
    });

    const getTipo = (f) => String(f?.tipo ?? f?.tipo ?? 'Entrada').toLowerCase(); // 'entrada' | 'saida'
    const isSaida = (f) => getTipo(f) === 'saida';
    const toNumber = (v) => (v === '' || v == null ? 0 : Number(v) || 0); // garante número    

    const totalVendasDigitadas = useMemo(() => {
        return Object.values(vendaValores).reduce((acc, v) => acc + (parseFloat(v || 0) || 0), 0);
    }, [vendaValores]);

    const reloadResumo = async () => {
        if (!caminhaoId || !competencia) return;
        setLoading(true);
        try {
            const data = await apiFetch(`/finance/resumo?caminhaoId=${caminhaoId}&competencia=${competencia}`);
            setResumo(data || null);
        } catch (e) {
            console.error(e);
            setResumo(null);
            setSnack(`Erro ao carregar resumo: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Função para buscar os totais do mês
    const reloadTotaisMes = async () => {
        if (!competencia) return;
        try {
            const data = await apiFetch(`/finance/saldo-caminhoes?competencia=${competencia}`);
            // data.totais = { cargaInicial, recargas, vendas, saldo }
            setTotaisMes(data?.totais || { cargaInicial: 0, recargas: 0, vendas: 0, saldo: 0 });
        } catch (e) {
            setSnack(`Erro ao carregar KPIs do mês: ${e.message}`);
        }
    };

    // Fechamento de ciclo
    const fecharCiclo = async () => {
        if (!resumo?.cicloId) return setSnack('Nenhum ciclo aberto.');
        try {
            setLoading(true);
            await apiFetch(`/finance/ciclos/${resumo.cicloId}/fechar`, {
                method: 'PUT',
                body: JSON.stringify({
                    dataFim: fecharData,
                    valorSobraMercadoria: parseFloat(fecharSobra || 0),
                    observacoes: fecharObs || null,
                }),
            });
            setDlgFechar(false);
            setSnack('Ciclo fechado com sucesso.');
            await reloadResumo();
            await reloadTotaisMes?.(); // se você já criou os KPIs do mês
        } catch (e) {
            setSnack(`Erro ao fechar ciclo: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };

    const reloadResumoDia = async () => {
        if (!resumo?.cicloId || !hoje) return;
        try {
            const [vd, dp] = await Promise.all([
                apiFetch(`/finance/vendas-dia?cicloId=${resumo.cicloId}&data=${hoje}`),
                apiFetch(`/finance/despesas-dia?cicloId=${resumo.cicloId}&data=${hoje}`),
            ]);
            setResumoDia({
                vendas: Number(vd?.total || 0),
                despesas: Number(dp?.total || 0),
            });
        } catch (e) {
            setSnack(`Erro ao carregar resumo do dia: ${e.message}`);
        }
    };

    const handleCancelar = async () => {
        setFornecedorSelected(0);
        setPagValor(0);
        setPagFavorecido("");
        setDlgPagamento(false);
        setPagObs("");
        setPagFormaId(0);
        resetPagamentoForm();
        resetDespesaForm();
        resetVendaForm();
    }

    const salvarPagamento = async () => {
        if (!resumo?.cicloId) return setSnack('Abra/Selecione um ciclo.');
        if (!pagData || !pagValor) return setSnack('Informe data e valor.');
        try {
            setLoading(true);
            await apiFetch('/finance/pagamentos', {
                method: 'POST',
                body: JSON.stringify({
                    cicloId: resumo.cicloId,
                    data: pagData,
                    valor: parseFloat(pagValor),
                    formaPagamentoId: pagFormaId || null,
                    favorecido: pagFavorecido || null,
                    fornecedorId: fornecedorSelected || null,
                    observacao: pagObs || null,
                    status: pagStatus,
                }),
            });
            setFornecedorSelected(0);
            setPagValor(0);
            setPagFavorecido("");
            setDlgPagamento(false);
            setPagObs("");
            setPagFormaId(0);
            setSnack('Pagamento registrado.');
            resetPagamentoForm();
            // recarregue o que quiser (ex.: resumo do dia, drawer, etc.)
            // await reloadResumoDia(); 
        } catch (e) {
            setSnack(`Erro ao salvar pagamento: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };


    // ======= Carregamentos iniciais
    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const [cams, fps, cats, fors] = await Promise.all([
                    apiFetch('/finance/caminhoes'),
                    apiFetch('/finance/formas-pagamento'),
                    apiFetch('/finance/categorias-despesa'),
                    apiFetch(`/fornecedores/${instancia}/todos`)
                ]);
                setCaminhoes(asArray(cams));
                setFormas(asArray(fps));
                setCategorias(asArray(cats));
                setFornecedor(asArray(fors));
            } catch (e) {
                console.error('Erro listas:', e);
                setSnack(`Erro ao carregar listas: ${e.message}`);
                setCaminhoes([]); setFormas([]); setCategorias([]); setFornecedor([]);
            } finally {
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => { reloadResumo(); }, [caminhaoId, competencia]);

    useEffect(() => { reloadTotaisMes(); }, [competencia]);

    // ======= Persistência local simples
    useEffect(() => { if (caminhaoId) localStorage.setItem("fin_caminhaoId", caminhaoId); }, [caminhaoId]);
    useEffect(() => { if (competencia) localStorage.setItem("fin_competencia", competencia); }, [competencia]);

    useEffect(() => { reloadResumoDia(); }, [resumo?.cicloId, hoje]);

    // ======= Ações
    const abrirCiclo = async () => {
        if (!caminhaoId || !competencia) return setSnack("Selecione caminhão e competência.");
        try {
            setLoading(true);
            await apiFetch(`/finance/ciclos`, {
                method: "POST",
                body: JSON.stringify({
                    caminhaoId: Number(caminhaoId),
                    competencia,             // YYYY-MM
                    dataInicio: cicloDataInicio, // YYYY-MM-DD
                    valorCargaInicial: parseFloat(cicloCargaInicial),
                }),
            });
            setDlgCiclo(false);
            setSnack("Ciclo aberto com sucesso.");
            setCicloCargaInicial("");
            await reloadResumo();
        } catch (e) {
            setSnack(`Erro ao abrir ciclo: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Reabri ciclo
    const reabrirCiclo = async () => {
        if (!resumo?.cicloId) return setSnack('Nenhum ciclo selecionado.');
        if (!window.confirm('Reabrir este ciclo? Lançamentos voltarão a ser permitidos.')) return;
        try {
            setLoading(true);
            await apiFetch(`/finance/ciclos/${resumo.cicloId}/reabrir`, {
                method: 'PUT',
                body: JSON.stringify({ limparSobra: true }), // defina false se quiser manter a sobra
            });
            setSnack('Ciclo reaberto.');
            await reloadResumo();
            await reloadTotaisMes?.();
        } catch (e) {
            setSnack(`Erro ao reabrir ciclo: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };


    const registrarRecarga = async () => {
        if (!resumo?.cicloId) return setSnack("Abra um ciclo primeiro.");
        try {
            setLoading(true);
            await apiFetch(`/finance/recargas`, {
                method: "POST",
                body: JSON.stringify({
                    cicloId: resumo.cicloId,
                    data: recData,
                    valor: parseFloat(recValor),
                    observacoes: recObs || null,
                }),
            });
            setDlgRecarga(false);
            setRecValor(""); setRecObs("");
            setSnack("Recarga registrada.");
            await reloadResumo();
        } catch (e) { setSnack(`Erro ao registrar recarga: ${e.message}`); }
        finally { setLoading(false); }
    };


    // total prévia (com sinal aplicado por Tipo)
    const totalVendasPreview = useMemo(() => {
        return asArray(formas).reduce((acc, f) => {
            const v = Math.abs(toNumber(vendaValores[f.id]));
            return acc + (isSaida(f) ? -v : v);
        }, 0);
    }, [formas, vendaValores]);

    const registrarVenda = async () => {
        if (!resumo?.cicloId) return setSnack("Abra um ciclo primeiro.");
        const itens = Object.entries(vendaValores)
            .map(([formaId, valor]) => ({ formaPagamentoId: Number(formaId), valor: parseFloat(valor || 0) }))
            .filter((i) => i.valor > 0);
        if (!itens.length) return setSnack("Informe pelo menos um valor de venda.");
        try {
            setLoading(true);
            await apiFetch(`/finance/vendas`, {
                method: "POST",
                body: JSON.stringify({
                    cicloId: resumo.cicloId,
                    data: vendaData,
                    observacoes: vendaObs || null,
                    itens,
                }),
            });
            resetVendaForm();          // ⬅️ limpa campos
            setDlgVenda(false);
            setVendaValores({}); setVendaObs("");
            setSnack("Vendas do dia registradas.");
            await reloadResumo();
        } catch (e) { setSnack(`Erro ao registrar vendas: ${e.message}`); }
        finally { setLoading(false); }
    };

    const registrarDespesa = async () => {
        if (!resumo?.cicloId) return setSnack("Abra um ciclo primeiro.");
        if (!despCategoria || !despValor) return setSnack("Preencha categoria e valor.");
        try {
            setLoading(true);
            await apiFetch(`/finance/despesas`, {
                method: "POST",
                body: JSON.stringify({
                    cicloId: resumo.cicloId,
                    data: despData,
                    categoriaId: Number(despCategoria),
                    valor: parseFloat(despValor),
                    observacao: despObs || null,
                }),
            });
            resetDespesaForm();
            setDlgDespesa(false);
            setDespCategoria(""); setDespValor(""); setDespObs("");
            setSnack("Despesa registrada.");
            await reloadResumo();
        } catch (e) { setSnack(`Erro ao registrar despesa: ${e.message}`); }
        finally { setLoading(false); }
    };

    // ======= UI Helpers
    const currency = (v) => (v == null ? "-" : v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));

    const kpis = [
        { label: "Carga Inicial", value: resumo?.valorCargaInicial, icon: <LocalShippingIcon /> },
        { label: "Recargas", value: resumo?.totalRecargas, icon: <AddIcon /> },
        { label: "Vendas", value: resumo?.totalVendas, icon: <MonetizationOnIcon onClick={() => openDetails('vendas')} /> },
        // { label: "Despesas", value: resumo?.totalDespesas, icon: <RemoveCircleOutlineIcon /> },
        { label: "Saldo", value: resumo?.saldoCaminhao, icon: <AccountBalanceWalletIcon /> },
    ];

    const kpis2 = [
        { label: "Total de descontos", value: resumo?.totalDescontos, icon: <LocalShippingIcon /> },
        { label: "Total fiado recebido", value: resumo?.totalFiado_Recebido, icon: <AddIcon /> },
        { label: "Total promissorias", value: resumo?.totalPromissorias, icon: <MonetizationOnIcon /> }
    ];


    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <AppBar position="static" sx={{
                bgcolor: "background.paper",
                color: "text.primary",
                boxShadow: "none",
                borderBottom: 1,
                borderColor: "divider",
            }}>
                <Toolbar>
                    <LocalAtmIcon sx={{ mr: 1 }} />
                    <Typography variant="h6">Movimento financeiro Caminhões e Lojas</Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <button
                        style={{ width: '120px', height: '40px', borderRadius: 10, backgroundColor: '#6a0dad', color: '#fff', }}
                        variant="primary"
                        size="small"
                        onClick={() => {
                            navigate('/home');
                        }}
                    >
                        <FaHome style={{ marginRight: '8px' }} /> {/* Ícone à esquerda */}
                        Home
                    </button>

                    <Tooltip title="Recarregar">
                        <IconButton onClick={reloadResumo}>
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>

            {loading && <LinearProgress />}

            <Container maxWidth={false} sx={{ py: 3 }}>
                {/* coluna central */}
                <Stack spacing={2} sx={{ width: '90%', maxWidth: 990, mx: 'auto' }}>

                    {/* KPIs do MÊS (Totais gerais) */}
                    {totaisMes && (
                        <Paper sx={{ p: 2, borderRadius: 4 }}>
                            <Stack spacing={2} style={{ marginRight: 30 }}>
                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                    <Typography variant="subtitle1">Total geral do mês</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Competência: {competencia}
                                    </Typography>
                                </Box>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <KpiCard
                                            title="Carga inicial (mês)"
                                            value={totaisMes.cargaInicial}
                                            icon={<LocalShippingIcon />}
                                            help="Soma da carga inicial dos ciclos da competência."
                                            currency={currency}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <KpiCard
                                            title="Recargas (mês)"
                                            value={totaisMes.recargas}
                                            icon={<AddIcon />}
                                            help="Total de recargas (entradas de mercadoria) no mês."
                                            currency={currency}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <KpiCard
                                            title="Vendas (mês)"
                                            value={totaisMes.vendas}
                                            icon={<MonetizationOnIcon />}
                                            help="Somatório das vendas do mês em todas as formas de pagamento."
                                            currency={currency}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} sm={6} md={3}>
                                        <KpiCard
                                            title="Despesas (mês)"
                                            value={totaisMesDespesas?.total ?? 0} // se você decidir expor também
                                            icon={<ReceiptLongIcon />}
                                            currency={currency}
                                            onClick={() => openDetails('despesas')}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} sm={6} md={3}>
                                        <KpiCard
                                            title="Saldo (mês)"
                                            value={totaisMes.saldo}
                                            icon={<AccountBalanceWalletIcon />}
                                            help="Saldo = Carga Inicial + Recargas − Vendas."
                                            currency={currency}
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>
                        </Paper>
                    )}

                    {/* Filtros */}
                    <Paper sx={{ p: 2, borderRadius: 4, maxWidth: 1100, mx: 'auto' }}>
                        <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            justifyContent="center"             // ⬅️ centraliza horizontalmente os itens
                        >
                            {/* Caminhões e Lojas */}
                            <Grid item xs={12} sm="auto">       {/* ⬅️ em xs ocupa linha inteira; de sm pra cima, largura auto */}
                                <FormControl sx={{ minWidth: 300, width: { xs: '100%', sm: 'auto' } }}>
                                    <InputLabel id="lab-cam">Caminhoes e Lojas</InputLabel>
                                    <Select
                                        labelId="lab-cam"
                                        label="Caminhão e Lojas"
                                        value={caminhaoId}
                                        onChange={(e) => setCaminhaoId(e.target.value)}
                                    >
                                        {asArray(caminhoes).map((c) => (
                                            <MenuItem key={c.id} value={String(c.id)}>
                                                {c.identificacao ? `${c.placa} • ${c.identificacao}` : c.placa}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Competência */}
                            <Grid item xs={12} sm="auto">
                                <TextField
                                    label="Competência"
                                    type="month"
                                    value={competencia}
                                    onChange={(e) => setCompetencia(e.target.value)}
                                    inputProps={{ max: '9999-12' }}
                                    sx={{ minWidth: 220, width: { xs: '100%', sm: 'auto' } }}  // ⬅️ largura mínima + responsivo
                                />
                            </Grid>

                            {/* Botões */}
                            <Grid item xs={12} sm="auto">
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    justifyContent="center"          // ⬅️ centraliza o grupo de botões
                                    alignItems="center"
                                    sx={{ flexWrap: 'wrap' }}
                                >
                                    <Tooltip title="Abrir ciclo do mês">
                                        <Button size="small" variant="outlined" onClick={() => setDlgCiclo(true)}
                                            startIcon={<AssignmentTurnedInIcon />} sx={{ whiteSpace: 'nowrap' }}>
                                            Abrir Ciclo
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Registrar recarga">
                                        <Button size="small" variant="outlined" onClick={() => setDlgRecarga(true)}
                                            startIcon={<AddIcon />} sx={{ whiteSpace: 'nowrap' }}>
                                            Recarga
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Registrar vendas do dia">
                                        <Button size="small" color="primary" variant="contained"
                                            onClick={() => setDlgVenda(true)} startIcon={<MonetizationOnIcon />}
                                            sx={{ whiteSpace: 'nowrap' }}>
                                            Vendas
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Registrar despesa">
                                        <Button size="small" variant="outlined" onClick={() => setDlgDespesa(true)}
                                            sx={{ whiteSpace: 'nowrap' }}>
                                            Despesa
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Registrar pagamento">
                                        <Button size="small" variant="outlined" onClick={() => setDlgPagamento(true)} sx={{ whiteSpace: 'nowrap' }}>
                                            Pagamento
                                        </Button>
                                    </Tooltip>

                                    {resumo?.status === 'ABERTO' && (
                                        <Tooltip title="Fechar ciclo (informar sobra e data)">
                                            <Button size="small" color="secondary" variant="contained"
                                                onClick={() => setDlgFechar(true)} sx={{ whiteSpace: 'nowrap' }}>
                                                Fechar Ciclo
                                            </Button>
                                        </Tooltip>
                                    )}
                                    {resumo?.status === 'FECHADO' && (
                                        <Tooltip title="Reabrir ciclo">
                                            <Button size="small" color="warning" variant="outlined"
                                                onClick={reabrirCiclo} sx={{ whiteSpace: 'nowrap' }}>
                                                Reabrir
                                            </Button>
                                        </Tooltip>
                                    )}

                                    <Button size="small" variant="text" onClick={() => openDetails('vendas')}>
                                        Detalhes
                                    </Button>

                                    <Tooltip title="Relatórios">
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={abrirRelatorios}
                                            sx={{ whiteSpace: 'nowrap' }}
                                        >
                                            Relatórios
                                        </Button>
                                    </Tooltip>

                                </Stack>
                            </Grid>
                        </Grid>
                    </Paper>

                    <Paper sx={{ p: 2, borderRadius: 4 }}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <TodayIcon fontSize="small" /> Resumo do dia
                            </Typography>
                            <TextField
                                size="small"
                                type="date"
                                label="Dia"
                                value={hoje}
                                onChange={(e) => setHoje(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Box>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <KpiCard
                                    title="Vendas (dia)"
                                    value={resumoDia.vendas}
                                    icon={<MonetizationOnIcon />}
                                    currency={currency}
                                    help="Somatório das vendas no dia selecionado."
                                    onClick={() => openDetails('vendas')}   // atalho pro Drawer
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <KpiCard
                                    title="Despesas (dia)"
                                    value={resumoDia.despesas}
                                    icon={<ReceiptLongIcon />}
                                    currency={currency}
                                    help="Somatório das despesas no dia selecionado."
                                    onClick={() => openDetails('despesas')} // atalho pro Drawer
                                />
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* KPIs */}
                    <Grid container spacing={2} justifyContent="center">
                        {kpis2.map((k) => (
                            <Grid item xs={12} sm={6} md={3} key={k.label}>
                                <Paper sx={{ p: 2, borderRadius: 4, height: '100%' }}>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Box>
                                            <Typography variant="body2" color="text.secondary">{k.label}</Typography>
                                            <Typography sx={{ fontWeight: 700, fontSize: 24 }}>{currency(Number(k.value || 0))}</Typography>
                                        </Box>
                                        {/* <Box>{k.icon}</Box> */}
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>

                    {/* KPIs */}
                    <Grid container spacing={2} justifyContent="center">
                        {kpis.map((k) => (
                            <Grid item xs={12} sm={6} md={3} key={k.label}>
                                <Paper sx={{ p: 2, borderRadius: 4, height: '100%' }}>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Box>
                                            <Typography variant="body2" color="text.secondary">{k.label}</Typography>
                                            <Typography sx={{ fontWeight: 700, fontSize: 24 }}>{currency(Number(k.value || 0))}</Typography>
                                        </Box>
                                        <Box>{k.icon}</Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>

                    {/* Detalhes do ciclo */}
                    <Paper sx={{ p: 2, borderRadius: 4 }}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                            <Typography variant="subtitle1">Detalhes do ciclo</Typography>
                            <Chip size="small" {...statusChipProps} />
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}><Typography variant="body2">Status: <b>{resumo?.status || '-'}</b></Typography></Grid>
                            <Grid item xs={12} sm={6} md={3}><Typography variant="body2">Início: <b>{resumo?.dataInicio || '-'}</b></Typography></Grid>
                            <Grid item xs={12} sm={6} md={3}><Typography variant="body2">Fim: <b>{resumo?.dataFim || '-'}</b></Typography></Grid>
                            <Grid item xs={12} sm={6} md={3}><Typography variant="body2">Ciclo ID: <b>{resumo?.cicloId || '-'}</b></Typography></Grid>
                        </Grid>
                    </Paper>

                </Stack>
            </Container>


            <FinanceDetailsDrawer
                open={detailsOpen}
                onClose={() => setDetailsOpen(false)}
                cicloId={resumo?.cicloId || null}       // 👈 foco no caminhão selecionado
                defaultTab={detailsTab}
                apiFetch={apiFetch}                      // opcional (reaproveita sua função)
                caminhaoLabel={caminhaoLabel}            // opcional (se você adicionou no header)
            />

            {/* ======= Dialog: Abrir Ciclo ======= */}
            <Dialog open={dlgCiclo} onClose={() => setDlgCiclo(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Abrir ciclo</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField
                            label="Data início"
                            type="date"
                            value={cicloDataInicio}
                            onChange={(e) => setCicloDataInicio(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Carga inicial (R$)"
                            type="number"
                            value={cicloCargaInicial}
                            onChange={(e) => setCicloCargaInicial(e.target.value)}
                            InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                        />
                    </Box>
                    <Box mt={2}>
                        <Typography variant="body2" color="text.secondary">
                            Competência selecionada: <b>{competencia}</b>
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDlgCiclo(false)}>Cancelar</Button>
                    <Button color="primary" variant="contained" onClick={abrirCiclo}>Abrir</Button>
                </DialogActions>
            </Dialog>

            {/* ======= Dialog: Recarga ======= */}
            <Dialog open={dlgRecarga} onClose={() => setDlgRecarga(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Registrar recarga</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField label="Data" type="date" value={recData} onChange={(e) => setRecData(e.target.value)} InputLabelProps={{ shrink: true }} />
                        <TextField label="Valor (R$)" type="number" value={recValor} onChange={(e) => setRecValor(e.target.value)} InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }} />
                        <TextField label="Observações" fullWidth value={recObs} onChange={(e) => setRecObs(e.target.value)} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDlgRecarga(false)}>Cancelar</Button>
                    <Button color="primary" variant="contained" onClick={registrarRecarga}>Salvar</Button>
                </DialogActions>
            </Dialog>

            {/* ======= Dialog: Vendas ======= */}
            <Dialog open={dlgVenda} onClose={() => setDlgVenda(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Vendas do dia</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField label="Data" type="date" value={vendaData} onChange={(e) => setVendaData(e.target.value)} InputLabelProps={{ shrink: true }} />
                        <TextField label="Observações" fullWidth value={vendaObs} onChange={(e) => setVendaObs(e.target.value)} />
                    </Box>
                    <Divider sx={{ my: 1.5 }} />
                    <Grid container spacing={2}>
                        {asArray(formas).map((f) => {
                            const tipo = getTipo(f); // 'entrada' | 'saida'
                            const isOut = tipo === 'saida';
                            const raw = vendaValores[f.id] ?? '';
                            return (
                                <Grid item xs={12} sm={6} key={f.id}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label={`${f.descricao} ${isOut ? '(– Saida)' : '(+ Entrada)'}`}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start" sx={{ color: isSaida(f) ? 'error.main' : 'inherit' }}>
                                                    R$ {isSaida(f) ? '−' : ''}
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-input': { color: isSaida(f) ? 'error.main' : 'inherit' },
                                            '& .MuiInputLabel-root': { color: isSaida(f) ? 'error.main' : 'inherit' },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: isSaida(f) ? 'error.light' : undefined },
                                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: isSaida(f) ? 'error.main' : undefined },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: isSaida(f) ? 'error.main' : undefined },
                                        }}
                                        value={raw}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            // mantém o usuário digitando número positivo
                                            setVendaValores((s) => ({ ...s, [f.id]: val }));
                                        }}
                                        // InputProps={{
                                        //     startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                        // }}
                                        // sx={{
                                        //     '& .MuiInputBase-root': isOut ? { bgcolor: 'error.lighter', color: 'error.main' } : undefined,
                                        // }}
                                        helperText={isOut ? 'Subtrai do total' : 'Soma no total'}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                    <Box mt={2}>
                        <Typography variant="body2">Total informado: <b>{currency(totalVendasDigitadas)}</b></Typography>
                        <Typography variant="body2">
                            Total (prévia): <b>{currency(totalVendasPreview)}</b>
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDlgVenda(false); resetVendaForm() }} >Cancelar</Button>
                    <Button color="primary" variant="contained" onClick={registrarVenda}>Salvar</Button>
                </DialogActions>
            </Dialog>

            {/* ======= Dialog: Despesa ======= */}
            <Dialog open={dlgDespesa} onClose={() => setDlgDespesa(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Registrar despesa</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField label="Data" type="date" value={despData} onChange={(e) => setDespData(e.target.value)} InputLabelProps={{ shrink: true }} />
                        <FormControl sx={{ minWidth: 180 }}>
                            <InputLabel id="lab-cat">Categoria</InputLabel>
                            <Select labelId="lab-cat" label="Categoria" value={despCategoria} onChange={(e) => setDespCategoria(e.target.value)}>
                                {categorias.map((c) => (
                                    <MenuItem key={c.id} value={String(c.id)}>{c.descricao}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField label="Valor (R$)" type="number" value={despValor} onChange={(e) => setDespValor(e.target.value)} InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }} />
                        <TextField label="Observação" fullWidth value={despObs} onChange={(e) => setDespObs(e.target.value)} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDlgDespesa(false)}>Cancelar</Button>
                    <Button color="primary" variant="contained" onClick={registrarDespesa}>Salvar</Button>
                </DialogActions>
            </Dialog>

            {/* Diálogo de fechamento                                 */}
            <Dialog open={dlgFechar} onClose={() => setDlgFechar(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Fechar ciclo</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <TextField
                            label="Data de fechamento"
                            type="date"
                            value={fecharData}
                            onChange={(e) => setFecharData(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Sobra de mercadoria (R$)"
                            type="number"
                            value={fecharSobra}
                            onChange={(e) => setFecharSobra(e.target.value)}
                            InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                        />
                        <TextField
                            label="Observações"
                            fullWidth
                            value={fecharObs}
                            onChange={(e) => setFecharObs(e.target.value)}
                        />
                    </Box>
                    <Box mt={2}>
                        <Typography variant="body2" color="text.secondary">
                            Dica: o saldo atual deve estar próximo da <b>sobra</b>. Saldo = Carga Inicial + Recargas − Vendas.
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDlgFechar(false)}>Cancelar</Button>
                    <Button color="secondary" variant="contained" onClick={fecharCiclo}>Fechar</Button>
                </DialogActions>
            </Dialog>

            {/* Diálogo de Pagamentos                                 */}
            <Dialog open={dlgPagamento} onClose={() => setDlgPagamento(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Novo Pagamento</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Data"
                                type="date"
                                fullWidth
                                value={pagData}
                                onChange={(e) => setPagData(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Valor"
                                type="number"
                                fullWidth
                                value={pagValor}
                                onChange={(e) => setPagValor(e.target.value)}
                                InputProps={{ inputProps: { min: 0, step: '0.01' } }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel id="pag-status">Status</InputLabel>
                                <Select
                                    labelId="pag-status"
                                    label="Status"
                                    value={pagStatus}
                                    onChange={(e) => setPagStatus(e.target.value)}
                                >
                                    <MenuItem value="EFETIVADO">Efetivado</MenuItem>
                                    <MenuItem value="PENDENTE">Pendente</MenuItem>
                                    <MenuItem value="CANCELADO">Cancelado</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="pag-forma">Forma de pagamento</InputLabel>
                                <Select
                                    labelId="pag-forma"
                                    label="Forma de pagamento"
                                    value={pagFormaId}
                                    onChange={(e) => setPagFormaId(e.target.value)}
                                >
                                    {asArray(formas).map(fp => (
                                        <MenuItem key={fp.id} value={String(fp.id)}>
                                            {fp.descricao || fp.codigo}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm="auto">
                            <FormControl sx={{ minWidth: 300, width: { xs: '100%', sm: 'auto' } }}>
                                <InputLabel id="lab-cam">Favorecido</InputLabel>
                                <Select
                                    labelId="lab-cam"
                                    label="Favorecido"
                                    value={fornecedorSelected}
                                    onChange={(e) => setFornecedorSelected(e.target.value)}
                                >
                                    {asArray(fornecedor).map((f) => (
                                        <MenuItem key={f.COD_FORNECEDOR} value={String(f.COD_FORNECEDOR)}>
                                            {f.NOME}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>


                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                label="Favorecido"
                                fullWidth
                                value={pagFavorecido}
                                onChange={(e) => setPagFavorecido(e.target.value)}
                                placeholder="Fornecedor/Colaborador/Outro"
                            />
                        </Grid> */}

                        <Grid item xs={12}>
                            <TextField
                                label="Observações"
                                fullWidth
                                value={pagObs}
                                onChange={(e) => setPagObs(e.target.value)}
                                multiline
                                minRows={2}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelar}>Cancelar</Button>
                    <Button variant="contained" onClick={salvarPagamento}>Salvar</Button>
                </DialogActions>
            </Dialog>


            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={!!snack}
                autoHideDuration={4000}
                onClose={() => setSnack("")}
                message={snack}
                action={
                    <IconButton color="inherit" onClick={() => setSnack("")}>
                        <CloseIcon />
                    </IconButton>
                }
            />

        </Box>

    );
}
